import React from "react";
import {
    ButtonVariant,
    ButtonSize,
    ButtonProps,
    BUTTON_VARIANT_CLASSES,
    BUTTON_SIZES
} from "../../../@types/ui-components";

const Button: React.FC<ButtonProps> = ({
                                           children,
                                           type = "button",
                                           onClick,
                                           className = "",
                                           disabled = false,
                                           variant,
                                           size,
                                           property = "",
                                           icon,
                                           id,
                                           title,
                                       }) => {
    const setButtonStyle: ButtonVariant =
        variant && BUTTON_VARIANT_CLASSES.includes(variant) ? variant : BUTTON_VARIANT_CLASSES[0];

    const setButtonSize: ButtonSize =
        size && BUTTON_SIZES.includes(size) ? size : BUTTON_SIZES[0];

    return (
        <button
            title={title}
            id={id}
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`btn ${className} ${setButtonStyle} ${setButtonSize} ${
                disabled ? "disabled" : ""
            } ${property ? `btn${property}` : ""} ${icon ? "btn-icon" : ""}`}
        >
            {icon && <span className="btn__icon">{icon}</span>}
            {children}
        </button>
    );
};

export default Button;
